const rolesDictionary = {
    admin: 1,
    accountManager: 2,
    client: 3,
    techAccountManager: 4,
  };

export default rolesDictionary;